module.exports = __webpack_public_path__ + "static/media/sidebar-3.87b946f8.jpg";